import {
	Component,
	AfterViewInit,
	OnInit,
	Input,
	ViewEncapsulation,
	Output,
	EventEmitter,
	ViewChild,
	ElementRef,
	ContentChild
} from "@angular/core";
import { IRouteObject } from "./topnavitem.types";
import { IdService } from "../../shared/services/id.service";

@Component({
	selector: "rbc-top-nav-item",
	templateUrl: "./topnavitem.component.html",
	encapsulation: ViewEncapsulation.None
})
export class TopnavitemComponent implements OnInit, AfterViewInit {
	isDropdownItem = false;
	@Input() dropdown = false;
	@Input() dropdownArrow = true;
	@Input() control;
	@Input() dropdownPositionX: "left"| "center"| "right" = "center";
	@Input() dropdownType = "click";
	@Input() dropdownTag: string;
	@Input() icon: string;
	@Input() iconWeight = "solid";
	@Input() router = false;
	@Input() target = "_blank";
	@Input() href: string;
	@Input() active = false;
	@Input() routerTo: string;
	@Input() profileImage: string; // deprecate at next minor version, replace with avatar prefix
	@Input() avatarImage: string;
	@Input() avatarText: string;
	@Input() itemId: string;
	@Input() routeObject: IRouteObject;
	@Input() exact: boolean;
	@Input() dropdownActive: boolean;

	wrapperClass;
	isOpen = false;

	@Output() onClick = new EventEmitter();
	@Output() popoverToggle = new EventEmitter<boolean>();
	@Output() buttonClick = new EventEmitter();

	@ViewChild("dropdownItem", { static: false }) dropdownItem: ElementRef;

	constructor(private idService: IdService) { }

	ngOnInit() {
		if (!this.itemId) {
			this.itemId = this.idService.generate();
		}

		this.dropdownArrow = this.dropdownType ? true : false;

		this.wrapperClass = this.dropdownArrow ? "rbc-top-nav-dropdown rbc-top-nav-dropdown-arrow" : "rbc-top-nav-dropdown";
	}

	ngAfterViewInit() {
		setTimeout(() => this.checkDropdownItem(), 250);
	}

	itemClicked(e) {
		this.onClick.emit(e);
	}

	checkDropdownItem() {
		if (this.dropdownItem) {
			let el = this.dropdownItem.nativeElement;

			while (el.parentElement && this.isDropdownItem === false) {
				el = el.parentElement;
				if (el.classList.contains("rbc-menu")) {
					this.isDropdownItem = true;
				}
			}
			this.dropdownItem.nativeElement.remove();
		}
	}

	openDropdown(event) {
		// this.popoverService.$_Popover_toggle(event);
		this.isOpen = !this.isOpen;
		this.dropdownActive = event;
		this.popoverToggle.emit(event);
	}

	buttonChildClick(event) {
		this.buttonClick.emit(event);
	}
}
